import React, { useRef, useEffect } from 'react';
import vw from 'rpf/un/vw';
import Scrollbar from 'smooth-scrollbar';
import styled from 'styled-components/macro';

const Wrap = styled.div`
  width: ${p => vw(p.width)};
  height: ${p => vw(p.height)};

  .scrollbar-track {
    width: ${vw(4)};
    background: none;
    ::after {
      content: ' ';
      width: ${vw(4)};
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      margin: auto;
      background-color: #d8d0c6;
    }
  }

  .scrollbar-thumb {
    width: ${vw(4)} !important;
    background: #c51f20;
    border-radius: ${vw(6)};
    z-index: 1;
  }
`;

const ScrollWrap = props => {
  const ref = useRef();
  useEffect(() => {
    const ins = Scrollbar.init(ref.current);
    return () => {
      ins.destroy();
    };
  }, []);
  return <Wrap {...props} ref={ref} />;
};

export default ScrollWrap;
